import { retryCancelablePromise } from '../core/utils/retryCancelablePromise';
export class FeedbackService {
    constructor(httpRequest) {
        Object.defineProperty(this, "httpRequest", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: httpRequest
        });
    }
    /**
     * Create feedback
     * Publish feedback for a page or more granular item of content on the page.
     * The feedback can be anonymous or contain user related data, such as email.
     * @returns Feedback New feedback created.
     * @throws ApiError
     */
    createFeedback({ orgId, projectId, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'POST', url: '/orgs/{orgId}/projects/{projectId}/feedback', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get feedback list
     * Get feedback list.
     * @returns FeedbackList OK.
     * @throws ApiError
     */
    getFeedbackList({ orgId, projectId, after, before, sort = '-id', filter, limit = 10, search, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/feedback', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, query: {
                'after': after,
                'before': before,
                'sort': sort,
                'filter': filter,
                'limit': limit,
                'search': search,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get feedback
     * @returns Feedback OK.
     * @throws ApiError
     */
    getFeedbackById({ orgId, projectId, feedbackId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/feedback/{feedbackId}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'feedbackId': feedbackId,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Update feedback
     * @returns Feedback OK.
     * @throws ApiError
     */
    updateFeedback({ orgId, projectId, feedbackId, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'PATCH', url: '/orgs/{orgId}/projects/{projectId}/feedback/{feedbackId}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'feedbackId': feedbackId,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Delete feedback
     * @returns void
     * @throws ApiError
     */
    deleteFeedback({ orgId, projectId, feedbackId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'DELETE', url: '/orgs/{orgId}/projects/{projectId}/feedback/{feedbackId}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'feedbackId': feedbackId,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Download feedback report as CSV file
     * Download feedback report as CSV file.
     * @returns binary OK.
     * @throws ApiError
     */
    getFeedbackReport({ orgId, projectId, after, before, sort = '-id', filter, limit = 10, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/feedback-reports', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, query: {
                'after': after,
                'before': before,
                'sort': sort,
                'filter': filter,
                'limit': limit,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
}
//# sourceMappingURL=FeedbackService.js.map